<template>
  <div>
    <hr class="h-1" />
  </div>
</template>

<script>

export default {
  name: 'HorizontalRule',
  props: ['content']
}
</script>

<style lang="scss" scoped>
/* LIST */
::v-deep {
  hr{
      border-top: 1px solid rgba(0,0,0,.1);
  }
}

</style>
